<div class="card" style="height: auto; width: 1000px;">
  <div class="card-header card-header-success card-header-icon">
    <div class="card-icon">
      <i class="material-icons">slideshow</i>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-10">
        <h3 class="card-title">{{nombre}}</h3>
      </div>
      <div class="col-sm-2 col-md-2 text-right">
        <button mat-icon-button (click)="onCloseClick()" style="color: black;"><mat-icon>clear</mat-icon></button>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div mat-dialog-content>
      <div *ngIf="show; else notShow">
        <img [src]="image" class="card-img-top" alt="Error : No se encontro imagen">
      </div>
      <ng-template #notShow>
        <div class="container" #fileContainer id="fileContainer">
          <div class="card-body d-flex flex-column justify-content-center align-items-center" *ngIf="banderaExcel === true || banderaPowerPoint === true || banderaWord === true">
            <i class="material-icons" style="font-size: 20rem; cursor:pointer" (click)="descargar()" (keydown.enter)="descargar()">cloud_download</i>
            <a (click)="descargar()" class="mt-3 underline" style="cursor:pointer">Download</a>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
  <mat-dialog-content>

  </mat-dialog-content>
</div>